<template>
    <div>
        <table class="table w-full">
            <thead>
                <tr>
                    <sortable-header @sort="handleSort" sort-by="title" :direction="sort_direction" :column="sort_column" class="text-left border-b-2 border-gray py-2 px-2">Name</sortable-header>
                    <sortable-header @sort="handleSort" sort-by="total_qty" :direction="sort_direction" :column="sort_column" class="text-right border-b-2 border-gray py-2 px-2">Qty Sold</sortable-header>
                    <sortable-header @sort="handleSort" sort-by="description" :direction="sort_direction" :column="sort_column" class="text-left border-b-2 border-gray py-2 px-2">Description</sortable-header>
                    <sortable-header @sort="handleSort" sort-by="size" :direction="sort_direction" :column="sort_column" class="text-left border-b-2 border-gray py-2 px-2">Size</sortable-header>
                    <sortable-header @sort="handleSort" sort-by="category_id" :direction="sort_direction" :column="sort_column" class="text-left border-b-2 border-gray py-2 px-2">Category</sortable-header>
                    <sortable-header v-if="hasFinanceRole" @sort="handleSort" sort-by="price_low" :direction="sort_direction" :column="sort_column" class="text-right border-b-2 border-gray py-2 px-2">Low Price</sortable-header>
                    <sortable-header v-if="hasFinanceRole" @sort="handleSort" sort-by="price_high" :direction="sort_direction" :column="sort_column" class="text-right border-b-2 border-gray py-2 px-2">High Price</sortable-header>
                    <sortable-header v-if="hasFinanceRole" @sort="handleSort" sort-by="profit" :direction="sort_direction" :column="sort_column" class="text-right border-b-2 border-gray py-2 px-2">Profit</sortable-header>
                    <sortable-header v-if="hasFinanceRole" @sort="handleSort" sort-by="margin" :direction="sort_direction" :column="sort_column" class="text-right border-b-2 border-gray py-2 px-2">Margin</sortable-header>
                    <sortable-header v-if="hasFinanceRole" @sort="handleSort" sort-by="total_sales" :direction="sort_direction" :column="sort_column" class="text-right border-b-2 border-gray py-2 px-2">Total Sales</sortable-header>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in data" :key="item">
                    <td>{{ item.title }}<span v-if="item.special_order">* <small class="text-xs text-red">(special order)</small></span></td>
                    <td class="text-right pr-2">{{ Number(item.total_qty) }}</td>
                    <td>{{ item.description }}</td>
                    <td>{{ item.size }}</td>
                    <td>{{ item.category }}</td>
                    <td v-if="hasFinanceRole" class="text-right">{{ toCurrency(Number(item.price_low)) }}</td>
                    <td v-if="hasFinanceRole" class="text-right">{{ toCurrency(Number(item.price_high)) }}</td>
                    <td v-if="hasFinanceRole" class="text-right">{{ toCurrency(item.profit) }}</td>
                    <td v-if="hasFinanceRole" class="text-right">{{ Number(item.margin) === 0 ? '--' : (Number(item.margin) * 100).toFixed(1) + '%' }}</td>
                    <td v-if="hasFinanceRole" class="text-right">{{ toCurrency(item.total_sales) }}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td class="text-right">Totals:</td>
                    <td class="text-right pr-2">{{ totalItemQty.toLocaleString() }}</td>
                    <td colspan="3" class=""></td>
                    <td v-if="hasFinanceRole"></td>
                    <td v-if="hasFinanceRole"></td>
                    <td v-if="hasFinanceRole" class="text-right">{{ toCurrency(totalItemProfit) }}</td>
                    <td v-if="hasFinanceRole" class="text-right">{{ totalProfitMargin !== 0 ? totalProfitMargin.toFixed(1) + '%' : '--' }}</td>
                    <td v-if="hasFinanceRole" class="text-right">{{ toCurrency(totalItemSales) }}</td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
import { usePage } from '@inertiajs/inertia-vue3'
import UseUserAuth from '@/Composables/UseUserAuth';
import SortableHeader from '@/Shared/SortableHeader';

export default {
    components: {
        SortableHeader,
    },

    setup () {
        const { hasFinanceRole } = UseUserAuth(usePage().props.value.user);

        return {
            hasFinanceRole,
        }
    },

    props: ['data', 'sort_column', 'sort_direction'],
    emits: ['sort'],

    methods: {
        handleSort (sort) {
            this.$emit('sort', sort);
        },
    },

    computed: {
        totalItemQty() {
            return this.data.reduce(function(accumulator, currentValue){
                return accumulator + Number(currentValue.total_qty);
            }, 0);
        },
        totalItemProfit() {
            return this.data.reduce(function(accumulator, currentValue){
                return accumulator + Number(currentValue.profit);
            }, 0);
        },
        totalProfitMargin() {
            return this.totalItemProfit / this.totalItemSalesHavingProfits * 100;
        },
        avgItemMargin() {
            let marginCount = this.data.filter(i => i.margin > 0).length;

            let totalMargin = this.data.reduce(function(accumulator, currentValue){
                return accumulator + (currentValue.margin > 0 ? currentValue.margin : 0);
            }, 0);

            return marginCount > 0 ? totalMargin * 100 / marginCount : 0;
        },
        totalItemSales() {
            return this.data.reduce(function(accumulator, currentValue){
                return accumulator + Number(currentValue.total_sales);
            }, 0);
        },
        totalItemSalesHavingProfits() {
            return this.data.reduce(function(accumulator, currentValue){
                return accumulator + (currentValue.profit ? Number(currentValue.total_sales) : 0);
            }, 0);
        }
    }

}
</script>